import { withStyles, withTheme } from "@material-ui/core";
import React, {memo} from "react";
import { compose } from "recompose";
import styles from "./styles";
import EditIcon from "@material-ui/icons/Edit";
import { withFeatureFlags } from "../../../../../../../../userProfile/featureFlagsContext";
import { PICKUP_MANAGEMENT_MODES } from "../../../PickupManagement/constants";
import StyledToolTip from "../../../../../../../common/StyledToolTip";
import appConstants from "../../../../../../../../appConstants";

class EditPickup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enable: false,
    };
    this.selectedInvalidPickup = null;
  }

  componentDidMount() {
    this.props.eventHub.on(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeEditPickupStatus
    );
  }

  componentWillUnmount() {
    this.props.eventHub.off(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeEditPickupStatus
    );
  }

  changeEditPickupStatus = ({ selectedPickups }) => {
    this.selectedInvalidPickup = selectedPickups.reduce((selectedInvalidPickup, pickup) => {
        if(selectedInvalidPickup) return selectedInvalidPickup;
        if(pickup.isCompleted) return "Completed";
        if(pickup.isVoided) return "Voided";
        return selectedInvalidPickup
      }, null)

    const isEnabled = selectedPickups.length === 1 && !this.selectedInvalidPickup;
    this.setState({
      enable: isEnabled,
    });
  };

  getTooltipMessage = (enablePickupEdit) => {
    if (!enablePickupEdit) {
      return "Edit pickup (Disabled)";
    } 
    if(this.selectedInvalidPickup) {
        return `${this.selectedInvalidPickup} pickup cannot be edited`
    }
    if (this.state.enable) {
      return "Click to edit pickup";
    }
    return "Select a single pickup to edit";
  };

  onEditPickupEvent = () => {
    if (this.state.enable) {
      this.props.eventHub.emit("pickupManagement", {
        action: PICKUP_MANAGEMENT_MODES.EDIT_PICKUP,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { enable } = this.state;
    const enablePickupEdit = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnablePickupEdit
    );
    return (
      <div
        className={`${classes.headerIconStyles} ${
          classes.iconLayout
        } glHeaderIcons ${
          enablePickupEdit && enable ? classes.enabledIcon : classes.disableIcon
        }`}
        onClick={enablePickupEdit && enable ? this.onEditPickupEvent : null}
      >
        <StyledToolTip title={this.getTooltipMessage(enablePickupEdit)}>
          <EditIcon />
        </StyledToolTip>
      </div>
    );
  }
}

export default compose(withStyles(styles), withFeatureFlags, withTheme())(memo(EditPickup));